import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { MdEmail, MdLock, MdVisibility, MdVisibilityOff } from 'react-icons/md';
import ForgotPassword from './ForgotPassword';
import { loginUser } from '../redux/actions/authActions';
import { AlmataMainLogo } from '../../assets/image';

const Login = () => {
  const dispatch = useDispatch();
  const { loading, error, isAuthenticated } = useSelector(state => state.auth);
  const [currentView, setCurrentView] = useState('login'); // 'login', 'forgot'
  const [formData, setFormData] = useState({
    email: '',
    password: ''
  });
  const [showPassword, setShowPassword] = useState(false);
  const [validationErrors, setValidationErrors] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
    
    // Clear validation error for this field when user starts typing
    if (validationErrors[name]) {
      setValidationErrors({
        ...validationErrors,
        [name]: ''
      });
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    e.stopPropagation();
    
    const errors = {};
    if (!formData.email.trim()) {
      errors.email = 'Email is required';
    }
    if (!formData.password.trim()) {
      errors.password = 'Password is required';
    }
    
    if (Object.keys(errors).length > 0) {
      setValidationErrors(errors);
      return;
    }
    
    setValidationErrors({});
    dispatch(loginUser(formData));
  };

  // Clear form on successful authentication
  useEffect(() => {
    if (isAuthenticated) {
      setFormData({ email: '', password: '' });
    }
  }, [isAuthenticated]);

  if (currentView === 'forgot') {
    return <ForgotPassword onBackToLogin={() => setCurrentView('login')} />;
  }
  return (
    <div className="login-container">
      <div className="login-card">
        <div className="login-header">
          <img 
            src={AlmataMainLogo}
            alt="Cyber Risk Report Logo" 
            className="login-logo-admin"
          />
          <h1 className="login-title">Welcome to Cyber Risk Report</h1>
          <p className="login-subtitle">Sign In to Super Admin </p>
        </div>
        
        <form onSubmit={handleSubmit} className="login-form">
          
          <div className="form-group">
            <label htmlFor="email" className='fs-6'>Email</label>
            <div className="input-wrapper">
              {/* <MdEmail className="input-icon" /> */}
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                onKeyDown={(e) => e.key === ' ' && e.preventDefault()}
                placeholder="Enter your email"
                style={{
                  borderColor: validationErrors.email ? '#dc2626' : '#e5e7eb'
                }}
              />
            </div>
            {validationErrors.email && (
              <span style={{ color: '#dc2626', fontSize: '0.875rem', marginTop: '0.25rem' }}>
                {validationErrors.email}
              </span>
            )}
          </div>
          
          <div className="form-group">
            <label htmlFor="password" className='fs-6'>Password</label>
            <div className="input-wrapper">
              {/* <MdLock className="input-icon" /> */}
              <input
                type={showPassword ? 'text' : 'password'}
                id="password"
                name="password"
                value={formData.password}
                onChange={handleChange}
                onKeyDown={(e) => e.key === ' ' && e.preventDefault()}
                placeholder="Enter your password"
                style={{
                  borderColor: validationErrors.password ? '#dc2626' : '#e5e7eb'
                }}
              />
              <button
                type="button"
                className="password-toggle"
                onClick={() => setShowPassword(!showPassword)}
              >
                {showPassword ? <MdVisibilityOff /> : <MdVisibility />}
              </button>
            </div>
            {validationErrors.password && (
              <span style={{ color: '#dc2626', fontSize: '0.875rem', marginTop: '0.25rem' }}>
                {validationErrors.password}
              </span>
            )}
            <button 
              type="button"
              className="forgot-password-link"
              onClick={() => setCurrentView('forgot')}
            >
              Forgot Password?
            </button>
          </div>
          <button type="submit" className="login-btn" disabled={loading}>
            {loading ? 'Signing in...' : 'Sign In'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default Login;